import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { Box, IconButton, styled } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TooltipMui, { tooltipClasses } from "@mui/material/Tooltip";
import { InfoOutlined } from "@mui/icons-material";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
        x: {
            grid: {
                display: false,
            },
            ticks: {
                padding: 20,
                font: {
                    size: 14,
                },
            },
        },
        y: {
            grid: {
                display: false,
            },
            ticks: {
                padding: 20,
                stepSize: 5,
                font: {
                    size: 14,
                },
            },
        },
    },

    plugins: {
        legend: {
            display: false,
        },
        title: {
            display: false,
        },
    },
    elements: {
        line: {
            borderWidth: 8,
            backgroundColor: "green",
        },
    },
};
const labels = ["Jan 1", "Jan 2", "Jan 3", "Jan 4", "Jan 5", "Jan 6", "Jan 7", "Jan 8"];

const SessionAndPageViews = () => {
    const theme = useTheme();

    const data = {
        labels,
        // Same background and border color to prevent showing the bullet/point
        datasets: [
            {
                label: "Sessions",
                data: [1, 2, 3, 4, 5],
                borderColor: theme.palette.primary.main,
                pointStyle: false,
            },
            {
                label: "Pageviews",
                data: [2, 5, 3, 2, 5],
                borderColor: theme.palette.secondary.main,
                pointStyle: false,
            },
        ],
    };

    const HtmlTooltip = styled(({ className, ...props }) => <TooltipMui {...props} classes={{ popper: className }} />)(
        ({ theme }) => ({
            [`& .${tooltipClasses.tooltip}`]: {
                backgroundColor: "#fff",
                maxWidth: 350,
                borderRadius: 10,
                padding: 10,
            },
        }),
    );
    return (
        <div className="pt-8  bg-white border border-slate-100 rounded-[10px] h-full">
            <div className="px-8  font-bold text-xl text-slate-600  flex w-full justify-between items-center">
                <span>Sessions vs. Pageviews</span>
                <HtmlTooltip
                    placement="left"
                    title={
                        <div className="shadow-xl px-4 py-2 rounded-lg">
                            <div className="font-bold text-base text-slate-600">Sessions vs. Pageviews</div>
                            <p className="text-slate-600 mb-2">
                                A session is the browsing session of a single user to your site.
                            </p>
                            <p className="text-slate-600">
                                A page view is defined as a view of a page on your site that is being tracked by the
                                Analytics tracking code. Each refresh of a page is also a new page view.
                            </p>
                        </div>
                    }
                >
                    <IconButton>
                        <InfoOutlined></InfoOutlined>
                    </IconButton>
                </HtmlTooltip>
            </div>
            <div className="p-2 md:p-4 lg:p-8 space-y-5">
                <div className="flex items-center space-x-10">
                    <div className="flex items-center space-x-2">
                        <Box sx={{ background: theme.palette.primary.main }} className="rounded-full w-4 h-4" />
                        <div className="text-slate-600">Sessions</div>
                    </div>
                    <div className="flex items-center space-x-2">
                        <Box sx={{ background: theme.palette.secondary.main }} className="rounded-full w-4 h-4" />
                        <div className="text-slate-600">Pageviews</div>
                    </div>
                </div>
                <Line options={options} data={data} className="w-full h-[240px]" />
            </div>
        </div>
    );
};

export default SessionAndPageViews;
